export  { default } from "./MyStory"